import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDriverDetails } from "../../storeSlices/dataSlice";
function Drivers() {
  const [details, setdetails] = useState({
    name: "",
    phone: "",
    liscence_no: "",
    address: "",
  });

  const dispatch = useDispatch();
  const [driverdetails, setdriverdetails] = useState([]);

  useEffect(() => {
    // dispatch(getDriverDetails());
    setdriverdetails(driver);
  }, []);
  const driver = useSelector((state) => state.dataReducer.drivers);

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("details : ", details);
    const response = await fetch(
      // `http://localhost:5000/driver/`,
      `${process.env.REACT_APP_BACKEND_URL}/driver/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );
    const json = await response.json();
    console.log("json : ", json);
    const inputfield = document.getElementsByClassName("entry");
    Object.entries(inputfield).forEach((element) => {
      element[1].value = "";
    });
  };
  return (
    <div>
      <div className="chalan-form-container">
        <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
          <label>
            Name
            <input
              className="entry"
              type="text"
              name="name"
              value={details.name}
              onChange={handleChange}
            />
          </label>

          <br />
          <label>
            Phone Number:
            <input
              className="entry"
              type="text"
              name="phone"
              value={details.phone}
              onChange={handleChange}
            />
          </label>
          <br />
          <label>
            Liscence No:
            <input
              className="entry"
              type="text"
              name="liscence_no"
              value={details.liscence_no}
              onChange={handleChange}
            />
          </label>

          <br />
          <label>
            Address :
            <input
              className="entry"
              type="text"
              name="address"
              value={details.address}
              onChange={handleChange}
            />
          </label>

          <br />

          <br />
          <input className="generate" type="submit" value="Add Driver" />
        </form>
      </div>
    </div>
  );
}

export default Drivers;
